import { useTheme } from "@mui/system";

export default function QrCodeIcon() {
  const theme = useTheme();
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H8V8H0V0ZM2 2V6H6V2H2ZM3 3H5V5H3V3ZM12 0H20V8H12V0ZM14 2V6H18V2H14ZM15 3H17V5H15V3ZM0 12H8V20H0V12ZM2 14V18H6V14H2ZM3 15H5V17H3V15Z"
        fill={theme.palette.rgd.primary}
      />
      <rect x="10" y="10" width="2" height="2" fill={theme.palette.rgd.primary} />
      <rect x="12" y="12" width="2" height="2" fill={theme.palette.rgd.primary} />
      <rect x="15" y="12" width="2" height="2" fill={theme.palette.rgd.primary} />
      <rect x="12" y="15" width="2" height="2" fill={theme.palette.rgd.primary} />
      <rect x="15" y="15" width="2" height="2" fill={theme.palette.rgd.primary} />
      <rect x="18" y="10" width="2" height="2" fill={theme.palette.rgd.primary} />
      <rect x="10" y="18" width="2" height="2" fill={theme.palette.rgd.primary} />
      <rect x="18" y="18" width="2" height="2" fill={theme.palette.rgd.primary} />
    </svg>
  )
}
